import { useNavigate } from "react-router-dom";
import { makeStyles, Grid, Box, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { DialogBox } from "../../components/boxes";
import { Icon, Dialog, Button } from "../../components/base";
import SuccessIcon from "../../assets/images/icons/success-icon.svg";
import CloseIcon from "../../assets/images/modals/CloseModal.svg";
import { PAGES } from "../index";

const useStyles = makeStyles(() => ({
  root: {
    width: 520,
    height: 386,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 80,
    height: 80,
    borderRadius: "100%",
    backgroundColor: COLORS.lightGreen,
  },
  typography: {
    maxWidth: 273,
    textAlign: "center",
    marginTop: 10,
  },
  successMsg: {
    color: COLORS.green,
    marginBottom: 60,
  },
  notLogin: {
    marginTop: 50,
  },
  closeicon: {
    textAlign: "right",
  },
}));

export const SuccessModal = ({ isOpen }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Dialog isOpen={isOpen} onClose={() => navigate(PAGES.login, { replace: true })}>
      <DialogBox>
        <div className={classes.closeicon}>
          <Icon
            src={CloseIcon}
            hoverable
            tooltip="Close"
            onClick={() => navigate(PAGES.login, { replace: true })}
          />
        </div>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classes.root}
          direction="column"
        >
          <Box className={classes.icon}>
            <Icon src={SuccessIcon} />
          </Box>
          <Box className={classes.typography}>
            <Typography variant="h4" className={classes.successMsg}>
              Password was sucessfully changed
            </Typography>
          </Box>
          <Button
            className={classes.notLogin}
            id="success-button"
            text="I’d like to login now"
            onClick={() => navigate(PAGES.login, { replace: true })}
          />
        </Grid>
      </DialogBox>
      <SuccessModal />
    </Dialog>
  );
};
